/**
 * Loại thu HĐSN DV theo dõi thực hiện
 */
export default {
  All: 0,
  RevenuePricingGovernment: 1,
  RevenueOtherServices: 3,
  RevenueOrderOfGovernment: 2,
};
